import * as React from "react";
const BackTransparentSvgIcon = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <foreignObject x={-7.11111} y={-7.11111} width={46.2222} height={46.2222}>
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style={{
          backdropFilter: "blur(3.56px)",
          clipPath: "url(#bgblur_0_3826_223_clip_path)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <g data-figma-bg-blur-radius={7.11111}>
      <rect width={32} height={32} rx={16} fill="#404548" fillOpacity={0.6} />
      <path
        d="M14.38 11.9534L10.3334 16L14.38 20.0467"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="white"
      />
      <path
        d="M21.6667 16H10.4467"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="white"
      />
    </g>
    <defs>
      <clipPath
        id="bgblur_0_3826_223_clip_path"
        transform="translate(7.11111 7.11111)"
      >
        <rect width={32} height={32} rx={16} />
      </clipPath>
    </defs>
  </svg>
);
export default BackTransparentSvgIcon;


